import { useState } from "react";
import { useEffect } from "react";

import { ANIMATION_DURATION } from "../lib/configs";
import { LastUpdateChip } from "./LastUpdateChip";
import { StatusChipVariant } from "./StatusChip";

export const LastActionTimeTracker = ({
  animation = true,
  label,
  triggered,
}: {
  animation?: boolean;
  label?: string;
  triggered: boolean | null | undefined;
}) => {
  const [lastActionTime, setLastActionTime] = useState<Date | null>(null);
  const [variant, setVariant] = useState<StatusChipVariant>("info");

  useEffect(() => {
    if (triggered) {
      setLastActionTime(new Date());
      if (animation) {
        setVariant("success");
        setTimeout(() => {
          setVariant("info");
        }, ANIMATION_DURATION);
      }
    }
  }, [triggered, animation]);

  return <LastUpdateChip label={label} lastUpdateTime={lastActionTime} variant={variant} />;
};
